var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYerlemicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 906.457,
    height: 906.568,
    viewBox: "0 0 906.457 906.568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M505.175,232.832q-3.3-19.39-7.906-37.777H83.392c3.675-8.127,7.638-16.113,11.939-23.882H619.862c4.3,7.77,8.3,15.755,11.954,23.882a336.022,336.022,0,0,1,14.247,37.777ZM3.5,280.7c1.209-8.09,2.739-16.081,4.521-23.956H652.45c1.793,7.875,3.312,15.866,4.505,23.956a325.963,325.963,0,0,1,3.506,37.729h-147.3c-.252-12.78-.92-25.386-1.961-37.729H3.5ZM1.724,366.265Q.455,354.452,0,342.351H660.461q-.418,12.081-1.708,23.914a326.725,326.725,0,0,1-6.319,37.777H508.692q2.342-18.531,3.506-37.777H1.724Zm75.853,85.61q-4.66-11.773-8.422-23.956H646.036q-3.762,12.2-8.4,23.956a334.738,334.738,0,0,1-17.79,37.735H490.65c3.685-12.138,7-24.739,9.852-37.735H77.577Zm99.094,171.173a330.665,330.665,0,0,1-38.718-23.919h384.58a329.047,329.047,0,0,1-192.327,61.659c30.727,0,59.667-13.642,85.084-37.74H176.672ZM333.813,0h2.865A328.389,328.389,0,0,1,522.608,61.654h-85.82C425.075,46.509,412.353,33.8,398.816,23.877H206.41A329.753,329.753,0,0,1,323.767,0h10.046ZM272.464,85.568a337.655,337.655,0,0,0-23.835,23.919H466.395a380.944,380.944,0,0,1,16.223,37.761h122.73a330.243,330.243,0,0,0-29.334-37.761A337.329,337.329,0,0,0,552.2,85.568H272.464ZM236.89,537.438q-9.281-11.536-17.543-23.919H605.295q-8.256,12.356-17.542,23.919a332.548,332.548,0,0,1-35.6,37.792h-99a328.621,328.621,0,0,0,19.73-37.792H236.89Z",
    transform: "translate(0 340.163) rotate(-31)",
    fill: "#366cb8",
    fillRule: "evenodd",
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYerlemicon);
export default __webpack_public_path__ + "static/media/yerlemicon.c2d2efb23aa5f4ac6010f2c47cb2ce1a.svg";
export { ForwardRef as ReactComponent };